import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import classes from './patients.module.scss';
import Button from '../../_common/Form/Buttons/Button';
import DOBPicker from '../../_common/Form/DatePickers/DOBPicker/DOBPicker';
import InputField from '../../_common/Form/TextFields/InputField';
import { getPatientsRequest } from '../../../store/actions/patients';
import { useQuery } from '../../../utils/hooks/useQuery';
import accountHelpers from '../../../utils/accountHelpers';
import utils from '../../../utils/utils';
import Modal from '../../_common/Modal/Modal';
import MergeModalContent from './MergeModalContent/MergeModalContent';
import PatientTable from './PatientTable/PatientTable';
import Loader from '../../_common/Loader/Loader';
import { changeMenuPath } from '../../../store/actions/menu';

const tableHeader = ['Name', 'Date of birth', 'Phone number', 'Address', 'Actions'];

const Patients = () => {
  const isAdmin = accountHelpers.isInOneOfRoles(['Admin', 'Pharmacy']);

  const { pathname } = useLocation();
  const { query, setQuery, queryToStringify } = useQuery();

  const dispatch = useDispatch();
  const { patientList, pageCount } = useSelector((store) => store.patients);

  const [requestData, setRequestData] = useState({
    userId: accountHelpers.getUser().id,
    page: query.page || 1,
    limit: query.limit || 15,
    name: query.name || '',
    dob: query.dob || '',
    address: query.address || '',
    phone: query.phone || '',
  });

  const [isMergeModalOpen, mergeModalToggle] = useState(false);
  const [requestLoading, setRequestLoading] = useState(true);

  const {
    name, dob, address, phone, page, limit,
  } = requestData;

  useEffect(() => {
    (async () => {
      const data = utils.deleteEmptyKeys({ ...requestData });

      await dispatch(getPatientsRequest(data));

      setRequestLoading(false);
    })();
  }, []);

  useEffect(() => {
    dispatch(changeMenuPath('Patients', `${pathname}${queryToStringify(query)}`));
  }, [query]);

  const changeRequestData = (path, value) => {
    setRequestData((prev) => ({ ...prev, [path]: value }));
  };

  const submitFilters = (e) => {
    e.preventDefault();

    updateFilters();
  };

  const updateFilters = async () => {
    setRequestLoading(true);

    const data = utils.deleteEmptyKeys({ ...requestData });

    data.page = 1;

    await dispatch(getPatientsRequest({ ...data }));

    delete data.userId;

    setQuery(data);

    setRequestLoading(false);
  };

  const clearFilters = async () => {
    setRequestLoading(true);

    setRequestData({
      userId: accountHelpers.getUser().id,
      page: 1,
      limit: 15,
      name: '',
      dob: '',
      address: '',
      phone: '',
    });

    setQuery({});

    await dispatch(getPatientsRequest({}));

    setRequestLoading(false);
  };

  const onChangePageData = async (path, count) => {
    const newQuery = utils.deleteEmptyKeys({ ...requestData, [path]: count });

    if (path === 'limit') {
      newQuery.page = 1;
    }

    setRequestData({ ...newQuery });

    await dispatch(getPatientsRequest(newQuery));
  };

  return (
    <div className={classes.wrapper}>
      <div className={classes.header}>
        <h2>Select a Patient</h2>

        {isAdmin && (
          <div>
            <Button
              className={classes.merge_btn}
              title="Merge patient"
              type="button"
              onClick={() => mergeModalToggle(true)}
            />

            <Button
              className={classes.add_btn}
              title="Add a new patient"
              type="button"
              href="/patients/add"
              reverseColor
              addButton
            />
          </div>
        )}
      </div>

      <div className={classes.filters}>
        <form className={classes.fields_wrapper} onSubmit={submitFilters}>
          <div className={classes.fields_group}>
            <div className={classes.field_wrapper}>
              <InputField
                label="Search by name"
                value={name}
                onChange={(value) => changeRequestData('name', value)}
              />
            </div>

            <div className={classes.field_wrapper}>
              <DOBPicker
                label="Search by DOB"
                date={dob}
                onChange={(date) => changeRequestData('dob', date)}
              />
            </div>
          </div>

          <div className={classes.fields_group}>
            <div className={classes.field_wrapper}>
              <InputField
                label="Search by address"
                value={address}
                onChange={(value) => changeRequestData('address', value)}
              />
            </div>

            <div className={classes.field_wrapper}>
              <InputField
                label="Search by phone"
                value={phone}
                onChange={(value) => changeRequestData('phone', value)}
              />
            </div>
          </div>

          <div className={classes.btns_wrapper}>
            <Button
              title="Search"
              type="submit"
            />

            <Button
              title="Clear"
              type="button"
              clearButton
              onClick={clearFilters}
            />
          </div>
        </form>

        {/* <div className={classes.assign_btn_wrapper}> */}
        {/*  <Button */}
        {/*    title="Assign to Me" */}
        {/*    className={classes.assign_btn} */}
        {/*    type="button" */}
        {/*    reverseColor */}
        {/*  /> */}
        {/* </div> */}
      </div>

      <div className={classes.load_wrapper}>
        {requestLoading
          ? <Loader />

          : (
            <PatientTable
              data={patientList}
              header={tableHeader}
              totalPage={+pageCount}
              page={+page - 1}
              limit={+limit}
              className={classes.table}
              onChange={onChangePageData}
            />
          )}
      </div>

      <Modal
        open={isMergeModalOpen}
        onClose={() => mergeModalToggle(false)}
        className={classes.merge_modal}
      >
        <MergeModalContent
          onCancel={() => mergeModalToggle(false)}
        />
      </Modal>
    </div>
  );
};

export default Patients;
